/**
 * @file
 * Attaches the behaviors for the Alert component.
 */

(function ($, Drupal, cookies, once) {
  'use strict';

  Drupal.behaviors.hunterdonAlert = {
    attach: function attach(context) {
      $(context)
        once('hunderdonAlert', '.alert', context)
        .forEach((alert) => {
          let cookieExpiry;
          const id = $(alert).data('alert');
          const expiry = $(alert).data('expiry');
          const cookieKey = 'Drupal_visitor_hide_alert_' + id;
          const isHidden = cookies.get(cookieKey);

          if (isHidden && typeof isHidden !== 'undefined') {
            $(alert).remove();
          }

          $(alert)
            .find('.alert__close')
            .click(function () {
              switch (expiry) {
                case '1 day':
                case '7 days':
                case '30 days':
                  $(this).parents('.alert').remove();
                  cookieExpiry = parseInt(expiry.split(' ')[0]);
                  cookies.set(cookieKey, true, { expires: cookieExpiry });

                  break;
                case 'Never':
                  $(this).parents('.alert').remove();
                  cookieExpiry = Infinity;
                  cookies.set(cookieKey, true, { expires: cookieExpiry });

                  break;
                case 'None':
                  $(this).parents('.alert').remove();

                  break;
                case 'Static':
                  // Static means alert can not be closed.

                  break;
              }
            });
        });
    }
  };
})(jQuery, Drupal, window.Cookies, once);
